import { AppstoreAddOutlined }          from '@ant-design/icons';
import { BarChartOutlined }             from '@ant-design/icons';
import { CalendarOutlined }             from '@ant-design/icons';
import { HomeOutlined }                 from '@ant-design/icons';
import { LaptopOutlined }               from '@ant-design/icons';
import { MobileOutlined }               from '@ant-design/icons';
import { MailOutlined }                 from '@ant-design/icons';
import { NotificationOutlined }         from '@ant-design/icons';
import { StarOutlined }                 from '@ant-design/icons';
import { SettingOutlined }              from '@ant-design/icons';
import { ShopOutlined }                 from '@ant-design/icons';
import { TagOutlined }                  from '@ant-design/icons';
import { TeamOutlined }                 from '@ant-design/icons';
import { UnorderedListOutlined }        from '@ant-design/icons';
import { UserOutlined }                 from '@ant-design/icons';
import { VideoCameraOutlined }          from '@ant-design/icons';
import TaxonomyModel                    from '@models/website/TaxonomyModel';
import EventTypeModel                   from '@models/website/EventTypeModel';
import StandTypologyModel               from '@models/website/StandTypologyModel';
import TagModel                         from '@models/website/TagModel';
import ProfessionModel                  from '@models/website/ProfessionModel';
import ParticipationModel               from '@models/website/ParticipationModel';
import { pathWithWebsiteEntertainment } from './hooks/useWebsiteEntertainment';
import FigureModel                      from '@models/website/FigureModel';
import PartnershipModel                 from '@models/website/PartnershipModel';
import MenuModel                        from '@models/website/MenuModel';
import { NavigationItem }               from '@widesk-ui/components/Navigation';
import openCKFinder                     from '@/helpers/openCKFinder';
import SitePageModel                    from '@models/website/SitePageModel';
import { SolutionOutlined }             from '@ant-design/icons';
import PlaceModel                       from '@models/website/PlaceModel';
import PartnershipTypeModel             from '@models/website/PartnershipTypeModel';
import Shape                            from '@/components/Shape';
import EventModel                       from '@models/website/EventModel';
import PlanningModel                    from '@models/website/PlanningModel';
import StandModel                       from '@models/website/StandModel';
import TimedNotificationModel           from '@models/website/TimedNotificationModel';
import PushNotificationModel            from '@models/website/PushNotificationModel';
import UserModel                        from '@models/website/UserModel';
import UserGroupModel                   from '@models/website/UserGroupModel';
import PartnerModel                     from '@models/website/PartnerModel';
import AdvertisementModel               from '@models/website/AdvertisementModel';
import StonecodeMailEditorMailModel     from '@models/website/StonecodeMailEditorMailModel';
import EventWorkflowModel               from '@models/website/EventWorkflowModel';
import WebsiteEntertainmentModel        from '@models/website/WebsiteEntertainmentModel';
import { SafetyCertificateOutlined }    from '@ant-design/icons';
import { SecurityScanOutlined }         from '@ant-design/icons';
import ContactTypeModel                 from '@models/website/ContactTypeModel';
import { ContactsOutlined }             from '@ant-design/icons';
import { ClearOutlined }                from '@ant-design/icons';
import CachePurgeModel                  from '@models/website/CachePurgeModel';
import MobileSliderModel                from '@models/website/MobileSliderModel';

const pathOfConfiguration = (to: string) => (
	`configuration${to}`
);

export default function nav(id: id): NavigationItem[] {
	return [
		{
			label: 'Accueil',
			icon: <HomeOutlined />,
			link: `/website_entertainments/${id}/home`,
		},
		{
			key: 'website',
			label: 'Site web',
			icon: <LaptopOutlined />,
			children: [
				{
					label: MenuModel.localize('plural'),
					link: pathWithWebsiteEntertainment(MenuModel.getSplitViewPath('desktop')),
				},
				{
					label: SitePageModel.localize('plural'),
					link: pathWithWebsiteEntertainment(SitePageModel.pagePath('splitView')),
				},
			],
		},
		{
			key: 'mobile',
			label: 'Application mobile',
			icon: <MobileOutlined />,
			children: [
				{
					label: TimedNotificationModel.localize('plural'),
					link: pathWithWebsiteEntertainment(TimedNotificationModel.pagePath('splitView')),
				},
				{
					label: PushNotificationModel.localize('plural'),
					link: pathWithWebsiteEntertainment(PushNotificationModel.pagePath('splitView')),
				},
				{
					label: MobileSliderModel.localize('plural'),
					link: pathWithWebsiteEntertainment(MobileSliderModel.pagePath('splitView')),
				},
				{
					label: MenuModel.localize('plural'),
					link: pathWithWebsiteEntertainment(MenuModel.getSplitViewPath('mobile')),
				},
				{
					label: 'Paramétrage',
					link: pathWithWebsiteEntertainment('/website_configs/app'),
				},
			],
		},
		{
			key: 'content',
			label: 'Contenu',
			icon: <AppstoreAddOutlined />,
			children: [
				{
					label: ParticipationModel.localize('plural'),
					link: pathWithWebsiteEntertainment(ParticipationModel.pagePath('splitView')),
				},
				{
					label: PartnershipModel.localize('plural'),
					link: pathWithWebsiteEntertainment(PartnershipModel.pagePath('splitView')),
				},
			],
		},
		{
			key: 'events',
			label: 'Événements',
			icon: <CalendarOutlined />,
			children: [
				{
					label: `Liste des ${EventModel.localize('plural', 'l')}`,
					link: pathWithWebsiteEntertainment(EventModel.pagePath('splitView')),
				},
				{
					label: PlaceModel.localize('plural'),
					link: pathWithWebsiteEntertainment(PlaceModel.pagePath('splitView')),
				},
				{
					label: `${PlanningModel.localize()} général`,
					link: pathWithWebsiteEntertainment('/planning_places/general'),
				},
				{
					label: `Gestion des ${PlanningModel.localize('plural', 'l')}`,
					link: pathWithWebsiteEntertainment(PlanningModel.pagePath('splitView')),
				},
				{
					label: `${PlanningModel.localize()} ${ParticipationModel.localize('plural', 'l')}`,
					link: pathWithWebsiteEntertainment('/planning_participations/general'),
				},
			],
		},
		{
			key: 'exhibitors',
			label: 'Exposants',
			icon: <ShopOutlined />,
			children: [
				{
					label: `Liste des ${StandModel.localize('plural', 'l')}`,
					link: pathWithWebsiteEntertainment(StandModel.getSplitViewPath('all')),
				},
				{
					label: `${StandModel.localize('plural')} à valider`,
					link: pathWithWebsiteEntertainment(StandModel.getSplitViewPath('to_validate')),
				},
			],
		},
		{
			key: 'statistics',
			label: 'Statistiques',
			icon: <BarChartOutlined />,
			children: [
				{
					label: 'Daisuki',
					link: pathWithWebsiteEntertainment('/statistics/daisuki'),
				}
			],
		},
		{
			key: 'settings',
			label: 'Paramètres du site',
			icon: <SettingOutlined />,
			style: { marginTop: 'auto', borderTop: '1px solid #FFFFFF40', borderRadius: 0 },
			children: [
				{
					label: WebsiteEntertainmentModel.localize('plural'),
					link: pathWithWebsiteEntertainment(`/editions/split`),
				},
				{
					label: 'Paramétrage',
					link: pathWithWebsiteEntertainment('/website_configs/website'),
				},
				{
					label: TaxonomyModel.localize('plural'),
					link: pathWithWebsiteEntertainment('/taxonomy_selection'),
				},
			],
		},
	];
}

export const navigationSettings: NavigationItem = {
	label: 'Configuration générale',
	icon: <SettingOutlined />,
	children: [
		{
			icon: <TagOutlined />,
			label: TaxonomyModel.localize('plural'),
			link: pathOfConfiguration(TaxonomyModel.pagePath('splitView')),
		},
		{
			icon: <StarOutlined />,
			label: FigureModel.localize('plural'),
			link: pathOfConfiguration(FigureModel.pagePath('splitView')),
		},
		{
			icon: <SolutionOutlined />,
			label: ProfessionModel.localize('plural'),
			link: pathOfConfiguration(ProfessionModel.pagePath('splitView')),
		},
		{
			icon: <SafetyCertificateOutlined />,
			label: PartnerModel.localize('plural'),
			link: pathOfConfiguration(PartnerModel.pagePath('splitView')),
		},
		{
			icon: <UserOutlined />,
			label: UserModel.localize('plural'),
			link: pathOfConfiguration(UserModel.pagePath('splitView')),
		},
		{
			icon: <TeamOutlined />,
			label: UserGroupModel.localize('plural'),
			link: pathOfConfiguration(UserGroupModel.pagePath('splitView')),
		},
		{
			icon: <CalendarOutlined />,
			label: EventTypeModel.localize('plural'),
			link: pathOfConfiguration(EventTypeModel.pagePath('splitView')),
		},
		{
			icon: <SecurityScanOutlined />,
			label: PartnershipTypeModel.localize(),
			link: pathOfConfiguration(PartnershipTypeModel.pagePath('splitView')),
		},
		{
			icon: <ShopOutlined />,
			label: StandTypologyModel.localize('plural'),
			link: pathOfConfiguration(StandTypologyModel.pagePath('splitView')),
		},
		{
			icon: <Shape.Triangle className="ant-menu-icon" width="1em" height="1em" fill="none" stroke="currentcolor" strokeWidth={0.8} />,
			label: `Statuts de programmation`,
			link: pathOfConfiguration(`/programming${EventWorkflowModel.pagePath('splitView')}`),
		},
		{
			icon: <Shape.Square className="ant-menu-icon" width="1em" height="1em" fill="none" stroke="currentcolor" strokeWidth={0.8} />,
			label: `Statuts de planification`,
			link: pathOfConfiguration(`/planification${EventWorkflowModel.pagePath('splitView')}`),
		},
		{
			icon: <Shape.Hexagon className="ant-menu-icon" width="1em" height="1em" fill="none" stroke="currentcolor" strokeWidth={0.8} />,
			label: `Statuts de communication`,
			link: pathOfConfiguration(`/communication${EventWorkflowModel.pagePath('splitView')}`),
		},
		{
			icon: <NotificationOutlined />,
			label: AdvertisementModel.localize('plural'),
			link: pathOfConfiguration(AdvertisementModel.pagePath('splitView')),
		},
		{
			icon: <TagOutlined />,
			label: TagModel.localize('plural'),
			link: pathOfConfiguration(TagModel.pagePath('splitView')),
		},
		{
			icon: <VideoCameraOutlined />,
			label: `Médiathèque`,
			onClick: () => openCKFinder(),
		},
		{
			icon: <MailOutlined />,
			label: StonecodeMailEditorMailModel.localize('plural'),
			link: pathOfConfiguration('/mails/split'),
		},
		{
			icon: <ContactsOutlined />,
			label: 'Formulaire de contact',
			link: pathOfConfiguration(ContactTypeModel.pagePath('splitView')),
		},
		{
			icon: <UnorderedListOutlined />,
			label: `Éditions de tous les festivals`,
			link: pathOfConfiguration(WebsiteEntertainmentModel.pagePath('splitView')),
		},
		{
			icon: <ClearOutlined />,
			label: CachePurgeModel.localize(),
			link: pathOfConfiguration('/cache_purge'),
		},
	],
};